export default __webpack_public_path__ + "static/media/DGAutoLtd-2.11e343eb.jpg";